import { useContext } from "react";
import { GlobalContext } from "../component/GlobalContext";
import ItemBox from "../component/ItemBox";
import ItemList from "../component/ItemList";
import Error from "./Error";

import "../sass/styles.scss";
import "./Forms.css";
import Heading from "../component/ps/heading/Heading";

const NoForms = () => {
  return (
    <div className="no-forms-container">
      <h1 className="no-forms-title"> There are no forms here!</h1>
      <strong>
        <p className="no-forms-text">
          Create new forms or log in to show your forms
        </p>
      </strong>
    </div>
  );
};

const FormList = ({ handleScrollTop, forms }) => {
  return (
    <>
      <div className={`items-container row items-container-markers`}>
        {forms.map((item, index) => {
          return (
            <div key={`form-${index}`}>
              <ItemList name={item.FORMS} />
            </div>
          );
        })}
        <span className="up icon-chevron-up" onClick={handleScrollTop}></span>
      </div>
    </>
  );
};

const FormBox = ({ handleScrollTop, forms }) => {
  return (
    <>
      <div className={`items-container row`}>
        {forms.map((item, index) => {
          return (
            <div key={`form-${index}`}>
              <ItemBox name={item.FORMS} />
            </div>
          );
        })}
        <span className="up icon-chevron-up" onClick={handleScrollTop}></span>
      </div>
    </>
  );
};

const Forms = ({ view = "box" }) => {
  const { settings, forms } = useContext(GlobalContext);

  const currentForms = forms.current || [];

  const handleScrollTop = () => {
    document.getElementById("base").scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="work-zone">
      <Heading
        title={"MY FORMS "}
        subtitle={
          currentForms &&
          `(${currentForms.length} ${
            currentForms.length === 1 ? "form" : "forms"
          } found.)`
        }
      />
      {currentForms && currentForms.length > 0 ? (
        <div className="container">
          {view === "list" ? (
            <FormList handleScrollTop={handleScrollTop} forms={currentForms} />
          ) : view === "box" ? (
            <FormBox handleScrollTop={handleScrollTop} forms={currentForms} />
          ) : (
            <Error />
          )}
        </div>
      ) : (
        <NoForms />
      )}
    </section>
  );
};

export default Forms;
